import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/person/stranded/list',
    method: 'post',
    data,
  })
}
export async function getDetail(params) {
  return request({
    url: '/person/stranded/detail',
    method: 'get',
    params,
  })
}
export async function alarmDeal(data) {
  return request({
    url: '/person/stranded/alarmDeal',
    method: 'post',
    data,
  })
}
